import { render, staticRenderFns } from "./AddFaqPage.vue?vue&type=template&id=2ee950c3"
import script from "./AddFaqPage.vue?vue&type=script&lang=js"
export * from "./AddFaqPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports